export const isNotNil = <T>(value: T): value is NonNullable<T> => {
    return value !== null && value !== undefined;
};

export const isNotEmpty = <T extends { length: number }>(value: T) => {
    return value.length > 0;
};
